// extracted by mini-css-extract-plugin
export default {"EditButton":"HIDList_EditButton__x0x6C"};